// extracted by mini-css-extract-plugin
export var label = "_5p-1";
export var reminder = "_5p-0";